import { flyInOutSlow, flyInOutSlowDelayed } from './../../libs/animations/fly-animations';
import { environment } from '@app/env';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { EvsbThankYouModel } from './evsb-thank-you.model';
import { EvsbThankYouService } from './evsb-thank-you.service';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from 'src/app/core/language/services/language.service';
import { LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-evsb-thank-you',
  templateUrl: './evsb-thank-you.component.html',
  styleUrls: ['./evsb-thank-you.component.scss'],
  animations: [flyInOutSlow, flyInOutSlowDelayed],
})
export class EvsbThankYouComponent implements OnInit, OnDestroy {
  public readonly environment = environment;
  public model: EvsbThankYouModel;
  public homePageLink = '';

  private notifier = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private pageService: EvsbThankYouService,
    private title: Title
  ) {
    this.updateHomePageLink(languageService.translate.currentLang);

    this.languageService.translate.onLangChange
      .pipe(takeUntil(this.notifier))
      .subscribe((langChangeEvent: LangChangeEvent) => {
        this.title.setTitle(this.languageService.translate.instant('modules.evsb.pages.title.thankYou'));

        this.updateHomePageLink(langChangeEvent.lang);
      });
  }

  ngOnInit(): void {
    this.model = this.pageService.getModel();
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  private updateHomePageLink(lang: string): void {
    this.homePageLink = `${environment.websiteUrl}/${lang}${
      lang === this.languageService.defaultLanguage ? environment.homePageB2BFr : environment.homePageB2BNl
    }`;
  }
}
